import { Outlet } from "react-router-dom";
import Header from "../Menu/Header";
import React, {useEffect, useState} from "react";
import SystemApi from "../Api/SystemApi";
import ClipLoader from "react-spinners/ClipLoader";
import packageJson from "../../package.json";

export default function Root({jsonServer}) {

    const newerVersion = (loadedVersion, latestVersion) => {
        const loaded = loadedVersion.split('.');
        const latest = latestVersion.split('.');
        const length = Math.max(loaded.length, latest.length);

        for (let i=0; i < length; i++) {
            const loadedV = i < loaded.length ? loaded[i] : 0;
            const latestV = i < latest.length ? latest[i] : 0;
            if (latestV === loadedV)
                continue;
            return latestV > loadedV
        }
        return false;
    }

    const [loadingConfig, setLoadingConfig] = useState(true);
    useEffect(() => {
        console.log('load config');
        const systemApi = new SystemApi(jsonServer);
        systemApi.getConfig(data => {
                console.log('config version: '+(data.klapp_version ? data.klapp_version : 'none'));
                if (data.klapp_version && newerVersion(packageJson.version, data.klapp_version)) {
                    console.log('newer version available, reload');
                    window.location.reload();
                }
                const dbs = data.dbs.filter(d => {return !isNaN(d)})
                sessionStorage.setItem('frontend.db', dbs[0] || new Date().getFullYear());
                sessionStorage.setItem('frontend.env', data.env);
                setLoadingConfig(false);
            },
            error => {
                setLoadingConfig(false);
                //setErrorMessage(error);
            })

    }, []);

    if (loadingConfig) {
        return (
            <div>
                <ClipLoader loading={loadingConfig} size={150} />
            </div>
        );
    }

    return (
        <div>
            <Header />
            <div className="content">
                <Outlet />
            </div>
        </div>
    );
}